import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import { NewDevelopersCrmRoutes } from "../../../routes/HomeRoutes/NewDevelopersCrmRoutes";

export const NewDevelopersCrmLayout = () => {
  return <SwitchRoute routes={NewDevelopersCrmRoutes} />;
};
